import React, { useEffect, useState } from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {React.FC<never>}
 */
export const Grid = () => {
    const [showGridLines, setShowGridLines] = useState(false);

    const storageKey = 'bva:grid-lines';

    const toggleGridlines = setShowGridLines.bind(null, (cV) => {
        localStorage.setItem(storageKey, String(!cV));
        return !cV;
    });

    useEffect(() => {
        window.toggleGridlines = toggleGridlines;

        const inStorage = localStorage.getItem(storageKey);

        if (inStorage) {
            setShowGridLines(inStorage === 'true');
        }

        const toggleGridWithKeys = (event) => {
            // CTRL + Shift + 4
            if (event.ctrlKey && event.shiftKey && (Number(event.key) === 4) || event.key === '$' ) {
                toggleGridlines();
            }
        };

        window.addEventListener('keydown',toggleGridWithKeys);

        return () => {
            window.removeEventListener('keydown', toggleGridWithKeys);
        };
    }, []);

    if (!showGridLines) {
        return null;
    }

    return (
        <div
            className='fixed inset-0 pointer-events-none'
            style={{ zIndex: '9999' }}>
            <div className='layout-container layout-site-outer-padding h-screen'>
                <div className='grid grid-cols-12 h-full gap-16 sm:gap-16'>
                    {Array(12).fill(null).map((_, i) => {
                        const classes = [];
                        return (
                            <div
                                className={classes.join(' ')}
                                key={i}
                                style={{ backgroundColor: '#e0e0e080' }} />
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Grid;
